import { PreloadJob } from '../../UnicronApp/preloader/PreloadJob';
import { FlagrSnapshotSlot } from './FlagrSnapshotSlot';

export const prefetchFlagrFlags = async (job: PreloadJob) => {
  const { services } = job;

  try {
    const flags = await services.flagr.flags(services.logger);
    services.cache.set(FlagrSnapshotSlot, flags);
  } catch {
    services.cache.set(FlagrSnapshotSlot, []);
  }
};
